import "./ProfileSelector.scss";

import type { Profile } from "../../types/profile";

interface ProfileCardProps {
  profile: Profile;
  onSelect: (profile: Profile) => void;
}

export const ProfileCard = ({ profile, onSelect }: ProfileCardProps) => {
  const initial = profile.name.charAt(0).toUpperCase();

  return (
    <div className="profile-card" onClick={() => onSelect(profile)}>
      <div
        className="profile-card__avatar"
        style={{ backgroundColor: profile.color }}
      >
        {profile.pictureUrl ? (
          <img
            src={`${profile.pictureUrl}?t=${Date.now()}`}
            alt={profile.name}
            className="profile-card__avatar-image"
          />
        ) : (
          initial
        )}
      </div>
      <div className="profile-card__name">{profile.name}</div>
    </div>
  );
};
